'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.signupLadySmallUrl = exports.logoUrl = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

exports.safeTitle = safeTitle;
exports.setQueryParams = setQueryParams;
exports.addImageQueryParams = addImageQueryParams;
exports.getAuctioneerLogoUrl = getAuctioneerLogoUrl;
exports.getAllUpcomingAuctionsUrl = getAllUpcomingAuctionsUrl;
exports.getAllEndedAuctionsUrl = getAllEndedAuctionsUrl;
exports.getAuctioneerDirectoryUrl = getAuctioneerDirectoryUrl;
exports.getAuctionResultsUrl = getAuctionResultsUrl;
exports.getPriceGuideBaseUrl = getPriceGuideBaseUrl;
exports.getPriceGuideUrl = getPriceGuideUrl;
exports.getIntellectualPropertyUrl = getIntellectualPropertyUrl;
exports.getPrivacyUrl = getPrivacyUrl;
exports.getTerminologyUrl = getTerminologyUrl;
exports.getTermsAndConditionsUrl = getTermsAndConditionsUrl;
exports.getItemUrl = getItemUrl;
exports.getCatalogUrl = getCatalogUrl;
exports.getCatalogConsoleUrl = getCatalogConsoleUrl;
exports.getNewCatalogConsoleUrl = getNewCatalogConsoleUrl;
exports.getNotFoundUrl = getNotFoundUrl;
exports.getSellerUrl = getSellerUrl;
exports.getThumbnailItemImageUrl = getThumbnailItemImageUrl;
exports.getMediumItemImageUrl = getMediumItemImageUrl;
exports.getLargeItemImageUrl = getLargeItemImageUrl;
exports.getXLargeItemImageUrl = getXLargeItemImageUrl;
exports.getItemImageUrl = getItemImageUrl;
exports.getCoverLotSecondaryImageUrl = getCoverLotSecondaryImageUrl;
exports.getCoverLotSecondaryImageUrlLarge = getCoverLotSecondaryImageUrlLarge;
exports.getCoverLotSecondaryImageUrlSmall = getCoverLotSecondaryImageUrlSmall;
exports.getItemCardImageUrl = getItemCardImageUrl;
exports.getCoverLotPrimaryImageUrl = getCoverLotPrimaryImageUrl;
exports.getCoverLotPrimaryImageUrlLarge = getCoverLotPrimaryImageUrlLarge;
exports.getCoverLotPrimaryImageUrlSmall = getCoverLotPrimaryImageUrlSmall;
exports.getMegaNavImageUrlLarge = getMegaNavImageUrlLarge;
exports.getMegaNavImageUrlSmall = getMegaNavImageUrlSmall;
exports.getFollowedSellersUrl = getFollowedSellersUrl;
exports.getMyBidsUrl = getMyBidsUrl;
exports.getMyAuctionsUrl = getMyAuctionsUrl;
exports.getProfileUrl = getProfileUrl;
exports.getSavedItemsUrl = getSavedItemsUrl;
exports.getSavedSearchesUrl = getSavedSearchesUrl;
exports.getCategoryLandingPageBaseUrl = getCategoryLandingPageBaseUrl;
exports.getSearchLandingPageBaseUrl = getSearchLandingPageBaseUrl;
exports.getSearchLandingPageMostPopular = getSearchLandingPageMostPopular;
exports.getSearchLandingPageMostBids = getSearchLandingPageMostBids;
exports.getCategoryLandingPageUrl = getCategoryLandingPageUrl;
exports.getCategoryPageUrlFromObject = getCategoryPageUrlFromObject;
exports.separateURL = separateURL;
exports.getCuratorImageUrl = getCuratorImageUrl;
exports.getSearchAuctioneerUrl = getSearchAuctioneerUrl;
exports.getSearchAuctioneerSoldUrl = getSearchAuctioneerSoldUrl;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var logoUrl = exports.logoUrl = 'https://p1.liveauctioneers.com/dist/images/logo_og.jpg?format=pjpg&auto=webp&quality=50';
var signupLadySmallUrl = exports.signupLadySmallUrl = 'https://p1.liveauctioneers.com/dist/images/SignupLadySmall.png?auto=webp&quality=50';

function safeTitle() {
    var title = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var safe = title.trim()
    // & to and
    .replace(/&/g, 'and')
    // comma to hyphen
    .replace(/,+/g, '-')
    // * to hyphen
    .replace(/\*+/g, '-')
    // ; to hyphen
    .replace(/;+/g, '-')
    // : to hyphen
    .replace(/:+/g, '-')
    // ' to hyphen
    .replace(/'+/g, '-')
    // " to hyphen
    .replace(/"+/g, '-').replace(/-*\s+-*/g, '-')
    // non letter/digit/& to nothing
    .replace(/[^a-zA-Z0-9-_&]/g, '')
    // many hyphen to one
    .replace(/--+/g, '-').toLowerCase();
    return safe;
}

function setQueryParams(url) {
    var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var cleanedUrl = url.replace(/\?.*/, '');
    var paramString = [];

    for (var key in queryParams) {
        var value = queryParams[key];
        paramString.push(key + '=' + value);
    }

    if (paramString.length > 0) {
        return cleanedUrl + '?' + paramString.join('&');
    }

    return cleanedUrl;
}

function addImageQueryParams(url, width) {
    var correctImageUrl = url.replace('http://', 'https://');
    return correctImageUrl + '?width=' + width + '&auto=webp&format=pjpg';
}

function getAuctioneerLogoUrl(auctioneer) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 110;

    return 'https://images.liveauctioneers.com/houses/logos/lg/' + auctioneer + '_large.jpg?width=' + width + '&format=pjpg&auto=webp&quality=50';
}

function getAllUpcomingAuctionsUrl(baseUrl) {
    var params = {
        catalog_status: 'live,online',
        page: 1,
        pageSize: 24
    };
    return baseUrl + '/catalog/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getAllEndedAuctionsUrl(baseUrl, sellerId) {
    var params = {
        catalog_status: 'done',
        house_id: sellerId
    };
    return baseUrl + '/catalog/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getAuctioneerDirectoryUrl() {
    return '/auctioneer/directory/';
}

function getAuctionResultsUrl() {
    return '/auction-results';
}

function getPriceGuideBaseUrl() {
    return '/price-guide/';
}

function getPriceGuideUrl(name, id) {
    return '' + getPriceGuideBaseUrl() + name + '/' + id + '/';
}

function getIntellectualPropertyUrl() {
    return '/intellectualproperty';
}

function getPrivacyUrl() {
    return '/privacy';
}

function getTerminologyUrl() {
    return '/terminology';
}

function getTermsAndConditionsUrl() {
    return '/termsandconditions';
}

function getItemUrl(id, title) {
    return '/item/' + id + '_' + safeTitle(title).replace(/-+$/, '');
}

function getCatalogUrl(id, title) {
    return '/catalog/' + id + '_' + safeTitle(title).replace(/-+$/, '') + '/';
}

function getCatalogConsoleUrl(classicBaseUrl, id) {
    return classicBaseUrl + '/bidapplet' + id;
}

function getNewCatalogConsoleUrl(id, title) {
    return '/console/' + id + '_' + safeTitle(title).replace(/-+$/, '') + '/';
}

function getNotFoundUrl() {
    return '/not-found';
}

function getSellerUrl(id, title) {
    var url = '/auctioneer/' + id + '/' + safeTitle(title).replace(/-+$/, '') + '/';
    return url;
}

function generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, size) {
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var cropImage = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    if (!sellerId || !catalogId || !itemId || !imgNumber) {
        return '';
    }

    var quality = limitQuality ? '&quality=50' : '';
    var crop = cropImage ? '&crop=' + cropImage : '';

    return 'https://p1.liveauctioneers.com/' + sellerId + '/' + catalogId + '/' + itemId + '_' + imgNumber + '_x.jpg?version=' + imageVersion + '&width=' + size + '&format=pjpg&auto=webp' + quality + crop;
}

function getThumbnailItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var gallery = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, gallery ? 64 : 128);
}

function getMediumItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 512);
}

function getLargeItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 768);
}

function getXLargeItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 1600, false);
}

function getItemImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var width = arguments[5];
    var limitQuality = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : true;
    var crop = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, width, limitQuality, crop);
}

function getCoverLotSecondaryImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var featured = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, featured ? 170 : 130);
}

function getCoverLotSecondaryImageUrlLarge(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 202);
}

function getCoverLotSecondaryImageUrlSmall(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 105);
}

function getItemCardImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 280);
}

function getCoverLotPrimaryImageUrl(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;
    var featured = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, featured ? 340 : 250);
}

function getCoverLotPrimaryImageUrlLarge(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 410);
}

function getCoverLotPrimaryImageUrlSmall(sellerId, catalogId, itemId, imgNumber) {
    var imageVersion = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    return generateImageUrl(sellerId, catalogId, itemId, imgNumber, imageVersion, 210);
}

function getMegaNavImageUrlLarge(category) {
    return 'https://p1.liveauctioneers.com/dist/images/desktop-' + category + '.jpg?height=382&format=pjpg&auto=webp&quality=50';
}

function getMegaNavImageUrlSmall(category) {
    return 'https://p1.liveauctioneers.com/dist/images/tablet-' + category + '.jpg?height=288&format=pjpg&auto=webp&quality=50';
}

function getFollowedSellersUrl() {
    return '/dashboard/followed-auctioneers';
}

function getMyBidsUrl() {
    return '/dashboard/my-bids';
}

function getMyAuctionsUrl() {
    return '/dashboard/my-auctions';
}

function getProfileUrl() {
    return '/dashboard/profile';
}

function getSavedItemsUrl() {
    return '/dashboard/saved-items';
}

function getSavedSearchesUrl(append) {
    return '/dashboard/search-and-alerts/' + (append ? append + '/' : '');
}

var categoryLandingIds = {
    art: 1,
    asian: 158,
    collectibles: 2,
    fashion: 3,
    furniture: 4,
    'home-garden': 5,
    jewelry: 6
};

function getCategoryLandingPageBaseUrl() {
    return '/c/';
}

function getSearchLandingPageBaseUrl() {
    return '/search/';
}

function getSearchLandingPageMostPopular() {
    return getSearchLandingPageBaseUrl() + '?parameters=%7B"sort":"-popularity","page":1%7D';
}

function getSearchLandingPageMostBids() {
    return getSearchLandingPageBaseUrl() + '?parameters=%7B"sort":"-bidCount","page":1%7D';
}

function getCategoryLandingPageUrl(category) {
    var categoryId = categoryLandingIds[category];
    if (categoryId) {
        return '' + getCategoryLandingPageBaseUrl() + category + '/' + categoryId + '/';
    }

    return getCategoryLandingPageBaseUrl();
}

function getCategoryPageUrlFromObject(category) {
    var url = getCategoryLandingPageBaseUrl();
    if (!category || !category.l1CategoryId) {
        return url;
    }
    url += category.l1CategoryUrl + '/';
    if ((0, _typeof3.default)(category.l2CategoryId) !== undefined && category.l2CategoryId) {
        url += category.l2CategoryUrl + '/' + category.l1CategoryId + '/' + category.l2CategoryId + '/';
    } else {
        url += category.l1CategoryId + '/';
    }
    return url;
}

function separateURL(url) {
    var match = url.match(/^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
    if (match === null) {
        return {
            host: '',
            path: ''
        };
    }
    return {
        host: match[2],
        path: match[5]
    };
}

function getCuratorImageUrl(baseUrl, curatorId, curatorImageFileName) {
    return baseUrl + '/' + curatorId + '/' + curatorImageFileName;
}

function getSearchAuctioneerUrl(sellerId) {
    var params = { house_id: '' + sellerId };
    return '/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}

function getSearchAuctioneerSoldUrl(sellerId) {
    var params = { house_id: '' + sellerId, page: 1, status: 'archive' };
    return '/search?parameters=' + encodeURIComponent((0, _stringify2.default)(params));
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/urls.js
// module id = CakR
// module chunks = 46